import { TableBody, TableCell, TableRow } from '@/components/ui';
import { Skeleton } from '@/components/custom';
import type { IDataTableBodySkeletonProps } from '@/interfaces';

const DataTableBodySkeleton = ({ rows = 8 }: IDataTableBodySkeletonProps) => {
	const skeletonKeys = Array.from({ length: rows }, () => crypto.randomUUID());

	return (
		<TableBody>
			{skeletonKeys.map(key => (
				<TableRow key={key} className="h-12">
					<TableCell className="w-[110px] py-1">
						<Skeleton className="h-4 w-20" />
					</TableCell>
					<TableCell className="w-[100px] py-1">
						<div className="flex items-center gap-2">
							<Skeleton className="h-4 w-4 rounded" />
							<Skeleton className="h-4 w-16" />
						</div>
					</TableCell>
					<TableCell className="w-[140px] py-1">
						<Skeleton className="h-4 w-24" />
					</TableCell>
					<TableCell className="py-1">
						<Skeleton className="h-4 w-40" />
					</TableCell>
					<TableCell className="w-[130px] text-right py-1">
						<Skeleton className="h-4 w-20 ml-auto" />
					</TableCell>
					<TableCell className="w-[90px] text-right py-1">
						<div className="flex items-center justify-end gap-1">
							<Skeleton className="h-8 w-8 rounded" />
							<Skeleton className="h-8 w-8 rounded" />
						</div>
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);
};

export default DataTableBodySkeleton;
